<template>
  <div class="hvh-flex align-center">
    <div class="days-value">{{ value }}</div>
      <div class="position-relative ml-2" style="border: 1px solid slategrey; width: 80px; height: 10px">
      <div style="position: absolute; height: 100%; border: 1px solid slategrey; left: 50%" />
      <div style="position: absolute; border: 4px solid; border-radius: 100%" :style="{ borderColor: colorStyle, left: circleLeft }" />
    </div>
  </div>
</template>
  
<script>
export default {
  noExport: true,
  props: ['value', 'average'],
  computed: {
    colorStyle() {
      if (this.value <= this.average)
        return 'green';
      else if (this.value <= this.average + 2)
        return 'orange';
      return 'red';
    },
    circleLeft() {
      return `${Math.min((this.value / this.average) * 45, 90)}%`;
    },
  },
  mounted() {
    window['thisSPCoreDays'] = this;
  },
}
</script>
<style lang="scss" scoped>
.days-value{
 width:20px;
 text-align: right;

}
  
 

</style>
